import React from "react";
import {
  BRANCH_TYPES,
  CITY_TIERS,
} from "../../../../constants/branch.constants";

const BranchBasicInfo = ({
  formData,
  updateField,
  errors,
  branches,
  isEdit = false,
  isMainBranch = false,
}) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Branch Name *
          </label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => updateField(null, "name", e.target.value)}
            className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 ${
              errors.name ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.name && (
            <p className="text-red-500 text-xs mt-1">{errors.name}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Branch Code {!isEdit && "(Auto-generated if empty)"}
          </label>
          <input
            type="text"
            value={formData.code}
            onChange={
              !isEdit
                ? (e) => updateField(null, "code", e.target.value.toUpperCase())
                : undefined
            }
            disabled={true}
            className={`w-full px-3 py-2 border border-gray-300 rounded-lg ${
              isEdit ? "bg-gray-100" : ""
            }`}
            placeholder={!isEdit ? "BR-MH-MUM-01" : ""}
          />
          {isEdit && (
            <p className="text-xs text-gray-500 mt-1">Code cannot be changed</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Branch Type
          </label>
          <select
            value={formData.branchType}
            onChange={(e) => updateField(null, "branchType", e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          >
            {Object.entries(BRANCH_TYPES).map(([key, label]) => (
              <option key={key} value={key}>
                {label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            City Tier
          </label>
          <select
            value={formData.cityTier}
            onChange={(e) => updateField(null, "cityTier", e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          >
            {Object.entries(CITY_TIERS).map(([key, label]) => (
              <option key={key} value={key}>
                {label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Parent Branch {!isEdit && "(for hierarchy)"}
          </label>
          <select
            value={formData.parentBranchId}
            onChange={(e) =>
              updateField(null, "parentBranchId", e.target.value)
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            disabled={isMainBranch}
          >
            <option value="">None (Independent Branch)</option>
            {branches
              .filter((b) => !isEdit || b._id !== formData._id)
              .map((branch) => (
                <option key={branch._id} value={branch._id}>
                  {branch.name} ({branch.code})
                </option>
              ))}
          </select>
          {isMainBranch && (
            <p className="text-xs text-gray-500 mt-1">
              Main branch cannot have a parent
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BranchBasicInfo;
